import ACTIONS from "./types";
import axios from "axios";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";

export const loginAs = (user) => async (dispatch) => {
  const { _id, email } = user;
  if (!_id || !email) return;
  dispatch({
    type: ACTIONS.FETCH_LOGIN,
    payload: user,
  });
  await axios
    .post(
      `${API_ENDPOINTS.AUTH_LOGIN}/login-as`,
      {
        _id: _id,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    )
    .then((res) => {
      // Set axios default token injection
      axios.defaults.headers.common["Authorization"] = "Bearer " + res.data.token;
      /**
       * Store the user auth data in local storage.
       * This has to be done sync as other components might depend on it
       * being persisted before mounting
       * */
      sessionStorage.removeItem("ordersTabSearchCache");
      sessionStorage.removeItem("monitoringFilterCache");
      dispatch({
        type: ACTIONS.FETCH_LOGIN_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.FETCH_LOGIN_FAILURE,
        payload: err.response.data,
      });
      setTimeout(() => {
        dispatch({
          type: ACTIONS.CLEAR_ERROR_TOAST,
          payload: null,
        });
      }, 5000);
    });
};

export const login = (email, password) => async (dispatch) => {
  dispatch({
    type: ACTIONS.FETCH_LOGIN,
    payload: null,
  });
  await axios
    .post(
      `${API_ENDPOINTS.AUTH_LOGIN}`,
      {
        email: email.trim().toLowerCase(),
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    )
    .then((res) => {
      // Set axios default token injection
      // axios.defaults.headers.common["X-Auth-Token"] = res.data.token;
      axios.defaults.headers.common["Authorization"] = "Bearer " + res.data.token;
      /**
       * Store the user auth data in local storage.
       * This has to be done sync as other components might depend on it
       * being persisted before mounting
       * */
      dispatch({
        type: ACTIONS.FETCH_LOGIN_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.FETCH_LOGIN_FAILURE,
        payload: err.response.data,
      });
      setTimeout(() => {
        dispatch({
          type: ACTIONS.CLEAR_ERROR_TOAST,
          payload: null,
        });
      }, 5000);
    });
};

export const logout = () => (dispatch) => {
  // Clear the stored authUser in localStorage
  localStorage.removeItem("state");
  localStorage.removeItem("loggedAsAnotherUser");
  sessionStorage.removeItem("ordersTabSearchCache");
  sessionStorage.removeItem("monitoringFilterCache");
  // Remove the axios default token
  delete axios.defaults.headers.common["Authorization"];
  dispatch({
    type: ACTIONS.LOGOUT,
    payload: null,
  });
};
